module.exports = __webpack_public_path__ + "static/media/add lesson plan.3fe362ac.svg";